import { useState, useCallback, useEffect } from "react";
import { Auth, useAuthedRequest } from "shared/@auth/Auth";
import { useLogger } from "shared/@hooks/useLogger";

export function useGracePeriod({ page = 0, limit = 15 }) {
  const { makeAuthedRequest } = Auth.useContainer();

  const { logError } = useLogger({ prefix: "useGracePeriod" });
  const [requestId, setRequestId] = useState(0);
  const [records, setRecords] = useState(null);
  const [isWaiting, setIsWaiting] = useState(false);

  const { data, loading, error } = useAuthedRequest(
    `/v1/membership/loa/graceperiod?page=${page}&limit=${limit}&req=${requestId}`
  );

  // Prevent records from becoming null between refreshes.
  useEffect(() => {
    if (data != null) {
      setRecords(data);
    }
  }, [data]);

  const refresh = useCallback(() => {
    setRequestId(requestId + 1);
  }, [requestId]);

  return {
    records,
    loading,
    isWaiting,
    refresh,
  };
}
